import { useMemo } from 'react';
import { filledRows } from './mppHelpers';
import type { MPPRow } from './types';
import styles from './DailyDashboard.module.css';

const DAYS = ['1', '2', '3', '4', '5'];

export function DayFilter({
  rows,
  activeModel,
  activeDay,
  onChange,
}: {
  rows: readonly MPPRow[];
  activeModel: string;
  activeDay: string;
  onChange: (day: string) => void;
}) {
  const idleDays = useMemo(() => {
    const slice = filledRows(rows.filter((r) => r.model_type === activeModel));
    const dc: Record<string, number> = {};
    slice.forEach((r) => {
      const d = String(r.day);
      dc[d] = (dc[d] ?? 0) + 1;
    });
    return new Set(DAYS.filter((d) => (dc[d] ?? 0) === 0));
  }, [rows, activeModel]);

  return (
    <div className={styles.dayFilter}>
      <span className={styles.dayLbl}>Day:</span>
      <button
        type="button"
        className={`${styles.dayBtn} ${activeDay === 'all' ? styles.active : ''}`}
        onClick={() => onChange('all')}
      >
        All days
      </button>
      {DAYS.map((d) => {
        const idle = idleDays.has(d);
        return (
          <button
            key={d}
            type="button"
            className={`${styles.dayBtn} ${activeDay === d ? styles.active : ''}`}
            disabled={idle}
            onClick={() => onChange(d)}
          >
            Day {d}
            {idle && <span className={styles.dayBtnSub}>idle</span>}
          </button>
        );
      })}
    </div>
  );
}
